(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["luxshade-hero-rotator"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = (root) => {
      if (root.dataset.lxStarted) return;
      root.dataset.lxStarted = '1';
      const imgs = root.querySelectorAll('.lx-rotator__img');
      if (imgs.length < 2) return;
      const delay = Math.max(2000, Number(root.dataset.interval) || 3000);
      let i = 0;
      setInterval(() => {
        if (document.hidden) return;
        imgs[i].classList.remove('is-active');
        i = (i + 1) % imgs.length;
        imgs[i].classList.add('is-active');
      }, delay);
    };
    const init = () => document.querySelectorAll('[data-lx-rotator]').forEach(start);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
